import * as React from "react"

import { cn } from "@/lib/utils"

const Field = React.forwardRef(({ className, children, ...props }, ref) => (
  <div ref={ref} className={cn("form-field", className)} {...props}>{children}</div>
))
Field.displayName = "Field"

const FieldLabel = React.forwardRef(({ className, required = false, children, ...props }, ref) => (
  <label ref={ref} className={cn("form-field-label", className)} {...props}>
    {children}
    {required ? <span className="form-field-required" aria-hidden="true">*</span> : null}
  </label>
))
FieldLabel.displayName = "FieldLabel"

const FieldDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p ref={ref} className={cn("form-field-description", className)} {...props} />
))
FieldDescription.displayName = "FieldDescription"

const FieldMessage = React.forwardRef(({ className, reserveSpace = false, children, ...props }, ref) => {
  if (!children && !reserveSpace) return null
  return <p ref={ref} className={cn("form-field-message", reserveSpace && "form-field-message--reserved", className)} {...props}>{children}</p>
})
FieldMessage.displayName = "FieldMessage"

export { Field, FieldDescription, FieldLabel, FieldMessage }
